import React, { useMemo, useEffect, useState } from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import { required } from "redux-form-validators";
import { renderField, renderselect, renderTextField } from "../../../../Components/Forms/renders";
import PropTypes from "prop-types";
import SwitcButton from "../../../../Components/Forms/switch";
import { fechgastenprofiel } from "../../../GastenVerbruik/Reducers/actions";

const SensorEditForm = ({ handleSubmit, gastenprofielen }) => {
  const requiredValidator = useMemo(() => required(), []);
  const dispatch = useDispatch();
  const [gastprofielOptions, setGastprofielOptions] = useState({});

  useEffect(() => {
    dispatch(fechgastenprofiel());
  }, [dispatch]);

  useEffect(() => {
    if (gastenprofielen && gastenprofielen.length > 0) {
      const options = { '': 'Geen gastprofiel gekoppeld' };
      gastenprofielen.forEach(profiel => {
        options[profiel._id] = profiel.naam;
      });
      setGastprofielOptions(options);
    }
  }, [gastenprofielen]);

  return (
    <div className="box box-default">
      <form onSubmit={handleSubmit}>
        <div className="box-body">
          <div className="row">
            <div className="col-6">
              <Field name="naam" type="input" validate={[requiredValidator]} component={renderField} label="Naam standplaatscategorie" />
              <Field name="beschrijving" type="input" component={renderTextField} label="Beschrijving standplaatscategorie (optioneel)" />
              <Field 
                name="gastenprofiel" 
                component={renderselect} 
                label="Gekoppeld Gastenprofiel" 
                options={gastprofielOptions}
              />
              <Field name="prijs" type="number" component={renderField} label="Basis prijs (wordt overschreven door gastprofiel)" />
              <Field name="voorschot" type="number" component={renderField} label="Voorschot per nacht" />
              <Field name="stekker" type="input" component={SwitcButton} label="Stekker verplicht aanwezig?" />
              <Field name="limiet" type="input" component={SwitcButton} label="Stroom automatisch uitschakelen bij overschrijding van het toegestane verbruik?" />
              <Field name="amperage" type="number" component={renderField} label="Maximale stroomsterkte (Ampère)" />
            </div>
          </div>
          <div className="pull-left submit">
            <input type="submit" className="btn btn-next btn-fill btn-success btn-wd btn-mg" name="next" value="Wijzigen" />
          </div>
        </div>
      </form>
    </div>
  );
};

SensorEditForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  gastenprofielen: PropTypes.array,
};

const ReduxFormSensorEdit = reduxForm({
  form: "categorie_edit", // a unique identifier for this form
})(SensorEditForm);

const mapStateToProps = (state) => ({
  initialValues: state.standplaatsen.categorie, // pull initial values from account reducer
  gastenprofielen: state.gastenverbruik.gastenprofielen,
});

export default connect(mapStateToProps)(ReduxFormSensorEdit);
